import React from 'react'

export const InstaSection = () => {
    return (
        <section className="bg-white py-12 overflow-hidden" aria-labelledby="insta-section-title">
            <div className="container mx-auto px-6 text-center mb-8">
                <p className="section-kicker">Sosyal Medya</p>
                <h2 id="insta-section-title" className="section-heading-lg">
                    Instagram'da Bizi Takip Edin
                </h2>
            </div>
            <div className="elfsight-app-4a838d94-47be-415c-85a4-0339404bfcc6" data-elfsight-app-lazy></div>
        </section>
    )
}
